export const create = () => {
	let subscribers = {};

	return {
		on(type, fn) {
			let arr = subscribers[type] || [];
			const index = arr.indexOf(fn);

			if (index < 0 && typeof fn === 'function') {
				subscribers[type] = [...arr, fn];
			}
		},
		one(type, fn) {
			fn._event_once = true;
			this.on(type, fn);
		},
		off(type, fn) {
			if (!fn && subscribers[type]) {
				return [...subscribers[type]].forEach(this.off.bind(this, type));
			}

			let arr = subscribers[type] || [];
			const index = arr.indexOf(fn);

			if (index > -1) {
				delete fn._event_once;
				arr.splice(index, 1);
			}

			if (arr.length === 0) {
				delete subscribers[type];
				return;
			}
		},
		trigger(type, data, context = null) {
			let arr = subscribers[type] || [];

			arr.filter((fn) => {
				fn.call(context, {type}, data);
				return fn._event_once;
			}).forEach(this.off.bind(this, type));
		},
	};
};

const global = create();

export const on = global.on.bind(global);
export const one = global.one.bind(global);
export const off = global.off.bind(global);
export const trigger = global.trigger.bind(global);



// WEBPACK FOOTER //
// ./src/js/tools/Emmiter.js